import { useEffect, useState } from "react";
import { sponsorshipAPI } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import PageTitle from "@/components/PageTitle";

export default function SponsorshipTerms() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    sponsorshipAPI.getTerms()
      .then((r) => setContent(r.data?.content || ""))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid="sponsorship-terms-page">
      <PageTitle title="Sponsorship Terms" />
      <h1 className="font-display text-3xl font-bold uppercase">Sponsorship Terms</h1>
      <div className="mt-6">
        {loading ? (
          <Skeleton className="h-64 w-full" />
        ) : content ? (
          <div className="whitespace-pre-wrap text-sm leading-relaxed text-muted-foreground" data-testid="sponsorship-terms-content">{content}</div>
        ) : (
          <p className="text-sm text-muted-foreground">The Sponsorship Terms have not been published yet. Please check back soon.</p>
        )}
      </div>
    </div>
  );
}
